'use client'

import { cn } from '@utils'
import { useState } from 'react'
import EnterView from './index'

export default function EnterViewAnimate({
  children,
  className,
  animate = '',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  animate: string
  children: React.ReactNode
}) {
  const [isInView, setIsInView] = useState(false)

  return (
    <EnterView
      className={cn(
        // 'opacity-0',
        { animate__animated: isInView },
        { [animate]: isInView },
        className
      )}
      {...props}
      onEnter={() => {
        setIsInView(true)
      }}
    >
      {children}
    </EnterView>
  )
}
